/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    equipmentCompanyId: {},
    equipmentType: {},
    equipmentHeadTypeCode: {}
  },
  getters: {
    equipmentCompanyId: state => state.equipmentCompanyId,
    equipmentType: state => state.equipmentType,
    equipmentHeadTypeCode: state => state.equipmentHeadTypeCode
  },
  mutations: {
    equipmentCompanyId: (state, data) => {
      state.equipmentCompanyId = data
    },
    equipmentType: (state, data) => {
      state.equipmentType = data
    },
    equipmentHeadTypeCode: (state, data) => {
      state.equipmentHeadTypeCode = data
    }
  },
  actions: {
    handleEquipmentCompanyId (equipmentCompanyId, data) {
      equipmentCompanyId.commit('equipmentCompanyId', data)
    },
    handleEquipmentType (equipmentType, data) {
      equipmentType.commit('equipmentType', data)
    },
    handleFieldHeader (equipmentHeadTypeCode, data) {
      equipmentHeadTypeCode.commit('equipmentHeadTypeCode', data)
    }
  }
}
